import { SizeField } from '../fields/size';
import { PriceField } from '../fields/price';
import { OrderSliderField } from '../fields/order_slider';

export function LimitForm() {
  return (
    <>
      <PriceField fieldName="price" showMidButton={true} />
      <SizeField priceFieldName="price" />
      <OrderSliderField />
    </>
  );
}
